import { getParamFromQua } from './utils';
import qblogin from '@tencent/qblogin';
import qbjsapi, { promiseAllSettled } from '@tencent/zixun-qbjsapi';
import { AegisModule } from './aegis';

const aeigs = new AegisModule();

const host = 'https://usercenter.html5.qq.com'; // 关注正式环境
const testHost = 'https://usercenterpre.html5.qq.com'; // 关注测试环境
const kdHost = 'https://we.kandian.qq.com'; // 看点tab关注正式环境
const kdTestHost = 'https://we.sparta.html5.qq.com'; // 看点tab关注测试环境

async function checkLogin() {
  try {
    const accountInfo = await qbjsapi.login.getAccountInfo();
    return accountInfo && accountInfo.qbid;
  } catch (error) {
    console.error('checkLogin error', JSON.stringify(error));
  }
}

async function getDeviceAndWifiInfo() {
  const [
    browserParam = {},
    qimei,
    // advertisingID,
    // idfv,
    connentType,
    // imsi,
    version,
    // macAddress,
    turingTicket,
  ] = await promiseAllSettled([
    qbjsapi.app.getBrowserParam(),
    qbjsapi.device.getQIMEI(),
    // qbjsapi.app.getAdvertisingID(),
    // qbjsapi.device.getIDFV(),
    qbjsapi.connect.getType(),
    // qbjsapi.device.getImsi(),
    qbjsapi.device.getVersion(),
    // qbjsapi.device.getMacAddress(),
    qbjsapi.device.getTuringTicket(),
  ]);
  const platform = getParamFromQua(browserParam.qua, 'PL') || 'other';
  const phoneName = getParamFromQua(browserParam.qua, 'MO');
  return {
    // eslint-disable-next-line no-nested-ternary
    terminal_type: platform === 'IOS' ? '3' : platform === 'ADR' ? '2' : '1',
    qimei: qimei.QIMEI || '',
    macAddress: '',
    advertisingIdentifier: '',
    idfv: '',
    imsi: '',
    os_version: version || '',
    ssid: connentType.ssid || '',
    brand: phoneName || '',
    qua2: browserParam.qua || '',
    guid: browserParam.guid || '',
    turingTicket: turingTicket.turingTicket,
  };
}

const actionMap = {
  follow: {
    real: `${host}/zixunproxy/follow`,
    test: `${testHost}/zixunproxy/follow`,
  },
  unFollow: {
    real: `${host}/zixunproxy/unfollow`,
    test: `${testHost}/zixunproxy/unfollow`,
  },
  queryFollowStatus: {
    real: `${host}/zixunproxy/query_follow_status_batch`,
    test: `${testHost}/zixunproxy/query_follow_status_batch`,
  },
  followUserBatch: {
    real: `${host}/trpc.mtt.zixun_proxy_server.zixun_proxy/FollowUserBatch`,
    test: `${testHost}/trpc.mtt.zixun_proxy_server.zixun_proxy/FollowUserBatch`,
  },
  kdFollow: {
    real: `${kdHost}/trpc.tkdwb.follow_cgi_svr.FollowCgiSvr/Follow`,
    test: `${kdTestHost}/trpc.tkdwb.follow_cgi_svr.FollowCgiSvr/Follow`,
  },
  kdUnFollow: {
    real: `${kdHost}/trpc.tkdwb.follow_cgi_svr.FollowCgiSvr/Unfollow`,
    test: `${kdTestHost}/trpc.tkdwb.follow_cgi_svr.FollowCgiSvr/Unfollow`,
  },
  kdQueryFollowStatus: {
    real: `${kdHost}/trpc.tkdwb.follow_cgi_svr.FollowCgiSvr/GetFollowStatus`,
    test: `${kdTestHost}/trpc.tkdwb.follow_cgi_svr.FollowCgiSvr/GetFollowStatus`,
  },
};

// 基于qblogin包多封装一层，懒初始化
let initSessionFlag = false;
const getSession = async (env) => {
  const params = {};
  let userSession = {};
  if (env === 'test') {
    params.cgiUrl = 'http://qblogin.sparta.html5.qq.com/trpc.tkdqb.qblogin.qblogin/CreateSession';
  }
  if (!initSessionFlag) {
    // 初始化
    userSession = await qblogin.initSession(params);
    initSessionFlag = true;
  } else {
    userSession = await qblogin.getSession();
  }
  return userSession;
};

const getHost = (action, env) => {
  const tempEnv = env === 'test' ? env : 'real';
  return actionMap[action][tempEnv];
};

async function fetcher(action, reqParams, env) {
  let timer = null;
  try {
    const apiHost = getHost(action, env);
    aeigs.infoAll({
      location: 'fetcher start',
      apiHost,
      reqParams,
    });
    const startTime = Date.now();
    timer = setTimeout(() => {
      aeigs.error({
        location: 'fetcher timeout',
        apiHost,
        reqParams,
      });
    }, 5000);
    return fetch(apiHost, {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify(reqParams),
    })
      .then((response) => {
        timer && clearTimeout(timer);
        aeigs.infoAll({
          location: 'fetcher response',
          response,
          costTime: Date.now() - startTime,
        });
        return response.json();
      });
  } catch (error) {
    timer && clearTimeout(timer);
    aeigs.error({
      location: 'fetcher error',
      error,
    });
    console.error(`${action} fetch error:`, error);
  }
}

function reportUserPrivacyEvent() {
  try {
    const reportParams = {
      dt_info_type: 'B1-2',
      dt_info_name: 'B1-2-4',
      dt_info_reason: 'BR5',
      dt_info_scene: 'BS7',
      dt_info_count: '1',
      dt_action_type: '1',
      dt_info_desc: '',
    };
    window.browser.app.reportUserPrivacyEvent(reportParams);
  } catch (error) {
    console.error(`reportUserPrivacyEvent error: ${error.message}`);
  }
}

export {
  checkLogin,
  getDeviceAndWifiInfo,
  qblogin,
  fetcher,
  getSession,
  aeigs,
  reportUserPrivacyEvent,
};
